export default __webpack_public_path__ + "static/media/insta.0a676ed2.webp";